import HomeEssentialsInsiderLogo from './logo'
import {homeEssentialsInsiderStylesUS} from './styles'

const baseConfig = {
  domainName: 'homeessentialsinsider' as const,
  domainType: 'insider' as const,
  siteName: 'Home Essentials Insider',
  logo: <HomeEssentialsInsiderLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/homeessentialsinsider.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-9TMZ7K2YG0',
    camelCaseUrl: 'HomeEssentialsInsider.com',
    title: (category: string, count: string) => `Home Improvement Insider | Top ${count} Insider Picks for ${category}`,
    description: (_category?: string, count?: string) =>
      `Upgrade your home with expert product picks. Home Improvement Insider reveals ${count} essential tools and materials for any project. Find the right products for real results.`,
    styles: homeEssentialsInsiderStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
